// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"12":"flow-game","18":"Edit","420":"Shop","757":"game","842":"map","879":"Score"}[chunkId] || chunkId) + "." + {"12":"8faa1bbb","18":"1225197d","420":"c4bd34bf","757":"6c8708d7","773":"0ae8181f","842":"cdc84ef2","879":"e4455712"}[chunkId] + ".css";
};